// @flow
import * as React from 'react';
import { ButtonBase, Divider, Drawer, Stack, Typography } from '@mui/material';
import { Envelope } from '@phosphor-icons/react';
import { useReactiveVar } from '@apollo/client';
import { menuCollapsed } from '../../app/ui/menu-toggle-button';
import { useEffect, useState } from 'react';
import { EmailTemplatesQuery, Portal, useEmailTemplatesQuery } from '../../shared';
import { Preloader } from '@coverright/features';
import { useLocation } from 'react-router-dom';


export const EmailTemplateDrawerButton = () => {
  const location = useLocation();
  const collapsed = useReactiveVar(menuCollapsed);
  const [template, setTemplate] = useState<EmailTemplatesQuery['emailTemplates']['data'][0]>()
  const [open, setOpen] = useState(false);
  const {data, loading} = useEmailTemplatesQuery({
    variables: { pageInput: {page: 0, size: 1000} },
    skip: !open,
  })
  const templates = data?.emailTemplates.data || [];

  useEffect(() => {
    if (location.pathname) {
      setOpen(false)
    }
  }, [location.pathname]);


  return (
    <>
      <Stack sx={{
        cursor: 'pointer',
        p: 1, '&:hover': {bgcolor: '#e9f2f5', '& p': {fontWeight: 600} }, borderRadius: '8px',
      }} direction={'row'} alignItems={'center'} onClick={() => setOpen(true)}>
        <Envelope size={18} color="#1c434f" style={{minWidth: 18}} />

        <Typography sx={{ display: 'inline-flex', ml: 1, opacity: collapsed ? 0 : 1, transition: 'opacity .5s ' }}
                    variant={'body2'}
                    color={'#1c434f'}
                    noWrap>Email templates</Typography>
      </Stack>
      <Drawer open={open}
              anchor={'left'}
              sx={{
                '& .MuiBackdrop-root, & .MuiPaper-root': {
                  left: collapsed ? 50 : 250,
                  boxShadow: 'none',
                }
              }}
              onClose={() => {
                setOpen(false)
                setTemplate(undefined);
              }}>
        <Stack p={2} minWidth={400} gap={2}>
          <Typography variant={'subtitle1'}>
            Email templates
          </Typography>
          <Divider sx={{ mb: 1 }} />
          {loading && <Preloader sx={{height: 150}} />}
          {!loading && <Stack direction={'row'}>

            <Stack width={400} gap={2}>
              {templates.map(t => (
                <ButtonBase key={t.id} onClick={() => setTemplate(t)}>
                  <Portal sx={{ py: 1, px: 2, width: 1, alignItems: 'flex-start' }}>
                    <Typography variant={'body2'} fontWeight={500}>{t.title}</Typography>
                  </Portal>
                </ButtonBase>
              ))}
            </Stack>

            {template && <Divider orientation={'vertical'} sx={{ mx: 3 }} />}

            <Stack sx={{
              ml: template ? 1 : 0,
              width: template ? 600 : 0,
              transition: 'width .3s',
              overflow: 'hidden',
            }}>
              <Typography variant={'body2'}
                          dangerouslySetInnerHTML={{ __html: template?.template || '' }} />
            </Stack>
          </Stack>}


        </Stack>
      </Drawer>
    </>
  )
};
